module.exports = __webpack_public_path__ + "img/no_tickets_available.5855d947.png";